/**
 * What a new teammate reads on their first screen in the console.
 *
 * This replaces `InvitationAcceptedNotice`, which confirmed the invitation and
 * then spent the rest of its words explaining that the console is a subset and
 * the real thing is a download. That was written when the browser was the
 * escape hatch from a desktop handoff card. It is the front door now, so the
 * copy leads with what the invitee can do in front of them and the app is an
 * addition offered underneath.
 *
 * The band is honest about the empty case. It cannot claim folders were shared
 * when none were — the invitee is looking at the same screen either way, and
 * being told they have work waiting when the tree is empty is worse than being
 * told nothing.
 */

import { ALERT_SUCCESS } from '../controlStyles';
import { DesktopAppOffer } from './DesktopAppOffer';

export function InvitationWelcome({
  orgName,
  projectName,
  sharedFolderCount,
  orgId,
}: {
  orgName: string | null;
  /** The project they landed in, when one resolved. */
  projectName?: string | null;
  /** Null when unknown; zero is meaningful and is not dressed up. */
  sharedFolderCount?: number | null;
  orgId?: string | null;
}) {
  const where = orgName
    ? projectName ? `You're in ${orgName}, on ${projectName}` : `You're in ${orgName}`
    : "You're on the team";

  return (
    <div className={`invitation-welcome grid gap-[0.4rem] ${ALERT_SUCCESS}`} role="status">
      <p className="font-semibold">{where}</p>
      <p className="text-nim">
        {sharedFolderCount
          ? `${sharedFolderCount} ${sharedFolderCount === 1 ? 'folder has' : 'folders have'} been shared with you. `
          : ''}
        Read and edit your team&rsquo;s documents, leave comments, work the trackers, and answer
        requests. Everything saves for everyone as you type.
      </p>
      <DesktopAppOffer className="mt-[0.3rem]" placement="welcome" orgId={orgId} dismissible />
    </div>
  );
}
